import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-non-clinical-survey',
  templateUrl: './non-clinical-survey.component.html',
  styleUrls: ['./non-clinical-survey.component.css']
})
export class NonClinicalSurveyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
